import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'; 


//PAGES
import Home from './pages/Home';  
import NoMatch from './pages/NoMatch'; 
import Successful from './pages/Successful'; 
import Unsuccessful from './pages/Unsuccessful'; 

//COMPONENTS 
import Layout from './components/Layout'; 
import NavigationBar from './components/NavigationBar';  
import FooterSection from './components/FooterSection';   

const App = () => { 

  return (
    <React.Fragment>

      <Router>
        <NavigationBar /> 
        <Layout>
          <Switch>
            <Route exact path="/" component={Home} />   
            <Route exact path="/Successful" component={Successful} />  
            <Route exact path="/Unsuccessful" component={Unsuccessful} />    
            <Route component={NoMatch} />
          </Switch>
        </Layout> 
        <FooterSection />
      </Router>

    </React.Fragment>

  );
}

export default App;